import React from "react";
import { UserScreen } from "../../layouts/user-screen.tsx";
import { SetNewPasswordForm } from "./set-new-password-form.tsx";
import { FontStyles } from "../../utils/font-styles.ts";

const textStyle = `font-normal ${FontStyles[`body-l`]}`;

export interface ChangePasswordProps {
  code: string;
}
export const ResetPasswordScreen: React.FC<ChangePasswordProps> = (props) => {
  return (
    <UserScreen headerText={"Reset your password"} dismissible={false}>
      <div className="flex flex-col gap-4.5 md:gap-7.5 px-4.5 pb-5 pt-2 md:px-7.5 md:pb-7.5">
        <p className={textStyle}>Choose a new password for your My ESPC account</p>
        <SetNewPasswordForm code={props.code} />
      </div>
    </UserScreen>
  );
};
